import { useQuery } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import { getPortfolioIdInstrumentsInstrumentIdV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePortfolioInstrumentQuery = (
	portfolioId?: number,
	instrumentId?: number,
) => {
	return useQuery({
		queryKey: PortfolioKeys.instrumentDetail(
			portfolioId ?? null,
			instrumentId ?? null,
		),
		queryFn: processResponse(() =>
			getPortfolioIdInstrumentsInstrumentIdV2(portfolioId!, instrumentId!),
		),
		enabled: Boolean(portfolioId) && Boolean(instrumentId),
	});
};
